import { render, staticRenderFns } from "./TestSetting.vue?vue&type=template&id=e14f576a&scoped=true"
import script from "./TestSetting.vue?vue&type=script&lang=js"
export * from "./TestSetting.vue?vue&type=script&lang=js"
import style0 from "./TestSetting.vue?vue&type=style&index=0&id=e14f576a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e14f576a",
  null
  
)

export default component.exports